import { axios, Response } from '../index'

export interface GetAdminResponse {
  id: string
  appUserId: number
  name: string
  avatarName: string
  avatar: string
  accessProfileId: number
  accessProfile: string
}

const getAdmins = (): Response<GetAdminResponse[]> => {
  return axios.get(`/v1/admins`)
}

export default getAdmins
